module.exports = __webpack_public_path__ + "media/images/subject_img/BIOLOGICAL ENGINEERING-BIOMEDICAL ENGINEERING-b6e865540de079688989f6f24765f70d.jpg";